<mat-card class="tools-card">
	<mat-card-header class="p-05">
		<div class="header-content">
			<div class="icon-container">
				<lucide-angular name="settings" class="custom-icon"></lucide-angular>
			</div>
			<mat-card-title>
				<a
					href="https://www.visec.com.ar/centro-de-recursos-visec/"
					target="_blank"
				>
					<app-title
						title="Centro de Recursos VISEC"
						headerType="3"
					></app-title>
				</a>
				<mat-card-subtitle class="mt-05"
					>Accede a recursos útiles para optimizar tu
					experiencia</mat-card-subtitle
				>
			</mat-card-title>
		</div>
	</mat-card-header>

	<mat-card-content class="card-content mt-1 mat-typography">
		<div class="tools-grid">
			@for (tool of tools; track tool.title) {
				<div class="tool-item">
					<div class="icon-container">
						<lucide-angular
							name="{{ tool.icon }}"
							class="custom-icon"
						></lucide-angular>
					</div>
					<div class="tool-info">
						<app-title [title]="tool.title" headerType="4"></app-title>
						<div class="tool-description mt-05">{{ tool.description }}</div>
					</div>
				</div>
			}
		</div>
	</mat-card-content>
</mat-card>
